import React from 'react'
import type { TeamStanding } from '../../Api'
import { Season } from '../../Context/SeasonContext/SeasonContext'
import { SEASON_CONFERNCES } from '../../Constant/season'
import { StandingsTableFull } from './StandingsTableFull'
import { StandingsTable } from './StandingsTable'
import { SlideDownFade } from '../Layout/Animations/SlideDownFade'

type HeaderProps = {
  items: TeamStanding[]
  seasonSelect: Season
  full?: boolean
  section?: string
  theme?: 'light' | 'dark'
  showLeagueStandings?: boolean
}

export const StandingsSection: React.FC<React.PropsWithChildren<HeaderProps>> = ({
  items,
  seasonSelect,
  full = false,
  showLeagueStandings,
  section = 'standings',
  theme = 'light',
}) => {
  const splitByConference = () => {
    if (showLeagueStandings) return false
    if (seasonSelect.seasonType === 'regular' && seasonSelect.year in SEASON_CONFERNCES)
      return true
    return false
  }

  return (
    <>
      {splitByConference() &&
        SEASON_CONFERNCES[seasonSelect.year].map((conf) => (
          <React.Fragment key={conf}>
            <SlideDownFade>
              {full && (
                <StandingsTableFull
                  items={items.filter((item) => item.conference === conf)}
                  conference={conf}
                  section={section}
                  theme={theme}
                  wideFirstCol={full}
                />
              )}
              {!full && (
                <StandingsTable
                  items={items.filter((item) => item.conference === conf)}
                  conference={conf}
                  section={section}
                  theme={theme}
                  wideFirstCol={full}
                />
              )}
            </SlideDownFade>
          </React.Fragment>
        ))}

      {!splitByConference() && (
        <SlideDownFade>
          {full && (
            <StandingsTableFull
              items={items}
              section={section}
              theme={theme}
              wideFirstCol={full}
            />
          )}
          {!full && (
            <StandingsTable
              items={items}
              section={section}
              theme={theme}
              wideFirstCol={full}
            />
          )}
        </SlideDownFade>
      )}
    </>
  )
}
